module.exports = __webpack_public_path__ + "static/media/pencil.12d00791.svg";